import productImage from "../../../assets/images/Products/kpi4_original.png";
import ProductInfo from "./ProductInfo";

function KPI() {
  return (
    <>
      <ProductInfo
        title="KPI And Analytics"
        primaryDescription=" Turn your data into insightful, interactive reports"
        secondaryDescription=" With Cloudlas KPI(Key Performance Indicators) and Analytics
                    WebParts, transform raw SharePoint data into stunning,
                    easy-to-understand visual reports. Customize every element
                    to match your goals—no coding required. Make smarter
                    decisions, faster."
        features={[
          "Transform real-time SharePoint data into visually stunning reports",
          "Charts that seamlessly integrate with SharePoint and MS Teams modern UI",
          "Responsive charts optimized for all screen sizes and resolutions",
          "List view threshold is not a problem for the charts",
          "Export the chart as PDF",
          "Easy customization",
          "Support for Teams Tab",
        ]}
        image={productImage}
        appsourceLink="https://appsource.microsoft.com/en-us/product/office/WA200008632?tab=Overview"
        youTubeLink="https://www.youtube.com/embed/zqmG66Ap6cU"
        pricings={[
          {
            userLimit: "Unlimited",
            price: "$99.99 USD",
            priceText: "/Month",
            secondaryText: "Billed Annually",
            paymentLink: "https://buy.stripe.com/cNieVf4aof63gOab2T9Ve0s", //"https://buy.stripe.com/fZubJ3dKYf6369wgnd9Ve0p",
          },
        ]}
      />
    </>
  );
}

export default KPI;
